import React from "react";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Card from 'react-bootstrap/Card';
import Label from "components/general/Label";
import { isMoreStartListStatus } from "helpers/status";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from "components/common/SportCode";
import useViewport from "components/general/useViewPort";
import SvgMirs from "components/presentation/SvgMirs";

export function CompetitorBlock(competitor) {
    const { breakPoint } = useViewport();
    let mobile = (breakPoint === 'xs' || breakPoint === 'sm' || breakPoint === 'md')
    const resultStatus = competitor?.result?.status?.code
    var colour = ''
    switch (competitor?.resultItem?.startOrder) {
        case 'b':
            colour = 'bg-blue';
            break;
        case 'g':
            colour = 'bg-green';
            break;
        case 'r':
            colour = 'bg-red';
            break;
        case 'y':
            colour = 'bg-yellow';
            break;
    }

    var resultDataText = ''
    var hastPhoto = false
    if (competitor?.resultItem?.resultDataText) {
        resultDataText = JSON.parse(competitor?.resultItem?.resultDataText)
        hastPhoto = resultDataText?.extra?.hasPhotofinish === 'true'
    }
    let classCompetitor;
    if (isMoreStartListStatus(resultStatus)) {
        classCompetitor = `score-name ${mobile ? 'px-1 w-60' : 'w-45'}`;
    } else {
        classCompetitor = `score-name ${mobile ? 'px-1 w-70' : 'w-60'}`
    }

    return (
        <div className="d-flex justify-content-start ">
            {isMoreStartListStatus(resultStatus) &&
                <div className={`w-10 text-end`}>
                    {hastPhoto
                        ? <SvgMirs className='mirsIcon' code='camera' />
                        : competitor?.resultItem?.resultRank
                    }
                </div>
            }
            <div className={`w-15 text-end ${colour}`}>
                {competitor?.resultItem?.bib}
            </div>
            <div className={`${mobile ? 'px-1 w-15' : 'w-30'}`}>
                <Noc  {...competitor?.participant?.organisation} showOnlyImage={mobile ? true : false} />
            </div>
            <div className={classCompetitor}>
                <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />
            </div>
        </div>
    )
}

const GetPosLabel = (pos) => {
    let out = ''
    switch (pos) {
        case '1':
            out = <Label data={'Header1stIn'} />
            break
        case '2':
            out = <Label data={'Header2ndIn'} />
            break
        case '3':
            out = <Label data={'Header3rdIn'} />
            break
        case '4':
            out = <Label data={'Header4thIn'} />
            break
        default:
            break
    }
    return out
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''

    let prevPos = GetPosLabel(competitor?.cp_prev_pos)
    let prevUnit = competitor?.cp_prev_unit?.shortDescription
    let out = <span>{prevPos} {prevUnit}</span>

    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div></div>
            <div className=''>{competitorPlace ? competitorPlace : prevUnit ? out : <span>&nbsp;</span>}</div>
        </div>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header>
            <div className='score-header'>
                <span>{data?.eventUnit?.shortDescription}</span>
            </div>
        </Card.Header>
    )
}

export function CompetitorHeader({ data, bracket, phase }) {
    const resultStatus = data?.result?.status?.code
    return (
        <div className="d-flex flex-row">
            <div className="w-70 d-flex flex-row">
                {isMoreStartListStatus(resultStatus) &&
                    <div className="w-10 text-end fw-bold"><Label data="HeaderRk" /></div>
                }
                <div className="w-15 mx-1 text-start fw-bold"><Label data="HeaderBib" /></div>

                <div className={`${isMoreStartListStatus(resultStatus) ? "w-75" : "w-85"} text-start fw-bold`}><Label data="HeaderName" /></div>
            </div>

            <div className="w-30"></div>
        </div>
    )
}